"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const use_global_hook_1 = __importDefault(require("use-global-hook"));
const user_1 = require("./user");
const accountDropdown_1 = require("./accountDropdown");
const notification_1 = require("./notification");
var initialState = Object.assign({}, user_1.initialUserState, accountDropdown_1.initialAccountDropdownState, notification_1.initialNotificationState);
var actions = Object.assign({}, user_1.userActions, accountDropdown_1.accountDropdownActions, notification_1.notificationActions);
var useGlobal = use_global_hook_1.default(react_1.default, initialState, actions);
exports.default = useGlobal;
